import React from 'react';

import { Button } from '../Button';
import { useModalContext } from '../ModalContext';
import { useModals } from '../useModals';

export interface RecursiveModalProps {
  className?: string;
}

export const RecursiveModal = ({ className }: RecursiveModalProps) => {
  const { showModal } = useModals();

  const handleButton1Click = React.useCallback(() => {
    showModal({
      buttons: [{ close: true, label: 'Close' }],
      children: <RecursiveModalInternal />,
      title: 'Title Modal 1',
    });
  }, [showModal]);

  return (
    <>
      <Button className={className} label={'Show Recursive Modal'} onClick={handleButton1Click} />
    </>
  );
};

interface RecursiveModalInternalProps {
  level?: number;
}

const RecursiveModalInternal = ({ level = 1 }: RecursiveModalInternalProps) => {
  const { showModal, showOffcanvas } = useModals();
  const { close } = useModalContext();

  const handleButton1Click = React.useCallback(() => {
    close();
    showModal({
      buttons: [{ close: true, label: 'Close' }],
      children: <RecursiveModalInternal level={level + 1} />,
      title: `Title Modal ${level + 1}`,
    });
  }, [close, level, showModal]);

  const handleButton2Click = React.useCallback(() => {
    showModal({
      buttons: [{ close: true, label: 'Close' }],
      children: <RecursiveModalInternal level={level + 1} />,
      title: `Title Modal ${level + 1}`,
    });
  }, [level, showModal]);

  const handleButton3Click = React.useCallback(() => {
    close();
    showOffcanvas({
      children: <RecursiveModalInternal level={level + 1} />,
      title: `Title Offcanvas ${level + 1}`,
    });
  }, [close, level, showOffcanvas]);

  const handleButton4Click = React.useCallback(() => {
    showOffcanvas({
      children: <RecursiveModalInternal level={level + 1} />,
      title: `Title Offcanvas ${level + 1}`,
    });
  }, [level, showOffcanvas]);

  return (
    <>
      <p>
        <Button label={`Show Modal ${level + 1} closing this one`} onClick={handleButton1Click} />
      </p>
      <p>
        <Button label={`Show Modal ${level + 1} leaving this one open for later`} onClick={handleButton2Click} />
      </p>
      <p>
        <Button label={`Show Offcanvas ${level + 1} closing this one`} onClick={handleButton3Click} />
      </p>
      <p>
        <Button label={`Show Offcanvas ${level + 1} leaving this one open for later`} onClick={handleButton4Click} />
      </p>
    </>
  );
};
